<script lang="ts" setup>
import { CoinRank } from "@/types/coinRank";

const props = withDefaults(
  defineProps<{
    rank: CoinRank;
  }>(),
  {}
);
import { useRankText } from "@/composable/rank";
</script>
<template>
  <div class="p-4 flex justify-between rounded bg-base-200">
    <div class="flex flex-col justify-between gap-4">
      <span class="text-xl">{{ useRankText(rank) }}</span>
    </div>
    <div class="flex flex-col">
      <i class="iconfont icon-i-right font-bold" />
      <!--          <span></span>-->
      <!--          <span>最受欢迎排行榜</span>-->
    </div>
  </div>
</template>
